import type { ResourcesIn } from '@repo/api-codegen';
import type { SearchResult } from '../../../api';

export function mapEntityToResource(entity: SearchResult): ResourcesIn | null {
	if (['table', 'view'].includes(entity.entity_type)) {
		return {
			id: entity.id,
			database_name: entity.search_metadata?.database,
			schema_name: entity.search_metadata?.schema,
			table_name: entity.title,
			resource_level: 'table',
		};
	} else if (entity.entity_type === 'schema') {
		return {
			id: entity.id,
			database_name: entity.search_metadata?.database,
			schema_name: entity.title,
			table_name: undefined,
			resource_level: 'schema',
		};
	} else if (entity.entity_type === 'database') {
		return {
			id: entity.id,
			database_name: entity.title,
			schema_name: undefined,
			table_name: undefined,
			resource_level: 'database',
		};
	} else {
		return null;
	}
}
